<template>
  <div>
    <boleto-timeline :data="boletos" />
    <infinite-loading @infinite="infiniteHandler">
      <div slot="no-more">
        Já carregamos todas as suas faturas =)
      </div>
      <no-content-fatura slot="no-results" />
      <div slot="spinner">
        Carregando...
      </div>
    </infinite-loading>
  </div>
</template>
<script>
import InfiniteLoading from 'vue-infinite-loading'
import BoletoTimeline from './BoletoTimeline.vue'
import NoContentFatura from './NoContentFatura.vue'

export default {
  components: {
    InfiniteLoading,
    NoContentFatura,
    BoletoTimeline,
  },
  data() {
    return {
      pagination: { page: 1, size: 200 },
    }
  },
  computed: {
    boletos() {
      return this.$store.state.boleto.boletos
    },
  },
  mounted() {
    this.$store.dispatch('boleto/clear')
  },
  methods: {
    infiniteHandler($state) {
      this.$store
        .dispatch('boleto/fetchBoletos', { pagina: this.pagination.page })
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.pagination.page += 1
            $state.loaded()
          } else {
            $state.complete()
          }
        })
        .catch(() => $state.complete())
    },
  },
}
</script>
